export interface IParsedURL {
  protocol: string;
  host: string;
  pathname: string;
  search?: string;
  hash?: string;
  params?: Record<string, string>;
  port?: number;
  baseURL: string;
}

export function parseURL(url: string): IParsedURL {
  const localRegex = /\/{3}(\S+)\:(\d+)\/?(\S*)/;

  if (localRegex.test(url)) {
    const [, host, port, pathname] = url.match(localRegex) as RegExpMatchArray;

    return {
      protocol: '///',
      host,
      port: parseInt(port),
      pathname,
      baseURL: `///${host}:${port}`,
    };
  }

  try {
    const parsed = new URL(url);
    return {
      protocol: parsed.protocol,
      host: parsed.host,
      pathname: parsed.pathname.replace(/^(\/?)(.*)/, '$2'),
      search: parsed.search.replace('?', ''),
      hash: parsed.hash,
      params: Object.fromEntries(parsed.searchParams),
      baseURL: `${parsed.protocol}//${parsed.host}${parsed.port ? `:${parsed.port}` : ''}`,
    };
  } catch (err) {
    console.error(err);
  }
}
